import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
    Configuration : [],
    loading : false,
    error : null,
};

const ConfigurationSlice = createSlice({
    name:"Configuration",
    initialState,
    reducers: {
        fetchConfigurationSuccess: (state,action) => {
            state.loading = false;
            state.Configuration = action.payload;
        },
        fetchConfigurationFailure: (state,action) => {
            state.loading = false;
            state.error = action.payload
        }
    },
})

export const {
    fetchConfigurationSuccess,
    fetchConfigurationFailure
} = ConfigurationSlice.actions

export default ConfigurationSlice.reducer